/**
 * Shared date/time formatting utilities used across admin and manager features.
 */

/**
 * Formats a date string to a readable format
 */
export const formatSubscriptionDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return dateString;
  }
};

/**
 * Formats activity log timestamp to readable format
 * Example: "2025-10-06T10:49:12.011000" -> "Oct 6, 2025, 10:49 AM"
 */
export const formatActivityTimestamp = (timestamp: string): string => {
  try {
    const normalized = timestamp.endsWith("Z") ? timestamp : `${timestamp}Z`;
    const date = new Date(normalized);
    return date.toLocaleString("en-US", {
      timeZone: "Asia/Manila",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  } catch (error) {
    console.error("Error formatting timestamp:", error);
    return timestamp;
  }
};

/**
 * Formats token date to short format
 * Example: "2025-10-06T17:07:25.868000" -> "Oct 6, 2025"
 * Returns "-" for null, undefined, or invalid dates
 */
export const formatTokenDate = (
  dateString: string | null | undefined,
): string => {
  if (!dateString) {
    return "-";
  }

  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch (error) {
    console.error("Error formatting token date:", error);
    return "-";
  }
};
